export default __webpack_public_path__ + "/dist/images/wine-icon.dad6d1797bcaf0090bbf74bd52e3fb1d.svg";